import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { createResellerWallet, getAllReseller } from "../../../config/LiveApi";
import { toast } from "react-toastify";

/* ---------------- Styles ---------------- */

const pageWrapper = {
  // padding: "40px",
  backgroundColor: "#f9fafb",
  minHeight: "100vh",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

const card = {
  backgroundColor: "#ffffff",
  padding: "30px",
  borderRadius: "16px",
  boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
  maxWidth: "700px",
  width: "100%",
};

const heading = {
  fontSize: "22px",
  fontWeight: "600",
  marginBottom: "25px",
  color: "#111827",
};

const formGroup = {
  marginBottom: "18px",
  display: "flex",
  flexDirection: "column",
};

const labelStyle = {
  marginBottom: "6px",
  fontSize: "14px",
  fontWeight: "500",
  color: "#374151",
};

const inputStyle = {
  padding: "10px 12px",
  borderRadius: "8px",
  border: "1px solid #d1d5db",
  fontSize: "14px",
  outline: "none",
};

const textareaStyle = {
  ...inputStyle,
  resize: "none",
  height: "80px",
};

const buttonStyle = {
  marginTop: "10px",
  padding: "10px 18px",
  borderRadius: "8px",
  border: "none",
  backgroundColor: "#00C389",
  // backgroundColor: "#2563eb",
  color: "#ffffff",
  fontWeight: "600",
  cursor: "pointer",
};

const messageStyle = {
  marginTop: "15px",
  fontSize: "14px",
};

/* ---------------- Component ---------------- */

const ResellerWallet = () => {
  const token = useSelector((store) => store.userReducer.token);
  const resellerUserId = useSelector((store) => store.userReducer.userId);

  const [formData, setFormData] = useState({
    name: "",
    resellerId: "",
    periodStart: "",
    periodEnd: "",
    amount: "",
    remarks: "",
  });

  const [resellers, setResellers] = useState([]);
  const [fetchingUsers, setFetchingUsers] = useState(false);

  const fetchAllData = async () => {
    try {
      const resellerRes = await getAllReseller(token);
      setResellers(resellerRes.data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (token) fetchAllData();
  }, [token]);

  const handleResellerSelect = (e) => {
    const selectedId = e.target.value;
    const selectedReseller = resellers.find((r) => r.id === selectedId);
    // console.log("selectedReseller",selectedReseller)
    if (!selectedReseller) return;

    setFormData((prev) => ({
      ...prev,
      resellerId: selectedReseller.id,
      name: `${selectedReseller.name}`,
    }));
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.resellerId) {
      toast.error("Please select reseller ");
      return;
    }

    if (!formData.name.trim()) {
      toast.error("Name is required ");
      return;
    }

    try {
      const start = new Date(formData.periodStart);
      start.setHours(0, 0, 0, 0);

      const end = new Date(formData.periodEnd);
      end.setHours(23, 59, 59, 999);
      const payload = {
        ...formData,
        periodStart: start.toISOString(),
        periodEnd: end.toISOString(),
        amount: String(formData.amount),
      };

      // console.log("Final Payload:", payload);

      const response = await createResellerWallet(payload, token);

      if (response.status) {
        toast.success("Wallet created successfully");

        setFormData({
          name: "",
          resellerId: "",
          periodStart: "",
          periodEnd: "",
          amount: "",
          remarks: "",
        });
      } else {
        toast.error("Failed to create wallet ");
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong ");
    }
  };

  return (
    <div style={pageWrapper}>
      <div style={card}>
        <h2 style={heading}>Reseller Fund Load</h2>

        <form onSubmit={handleSubmit}>
          <div style={formGroup}>
            <label>Select Reseller</label>
            <select
              onChange={handleResellerSelect}
              style={inputStyle}
              defaultValue=""
              disabled={fetchingUsers}
            >
              <option value="" disabled>
                {fetchingUsers ? "Loading reseller..." : "Select Reseller"}
              </option>

              {resellers.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.name || item.id || "N/A"}
                </option>
              ))}
            </select>
          </div>

          <div style={formGroup}>
            <label style={labelStyle}>Period Start</label>
            <input
              type="date"
              name="periodStart"
              value={formData.periodStart}
              onChange={handleChange}
              style={inputStyle}
              required
            />
          </div>

          <div style={formGroup}>
            <label style={labelStyle}>Period End</label>
            <input
              type="date"
              name="periodEnd"
              value={formData.periodEnd}
              onChange={handleChange}
              style={inputStyle}
              required
            />
          </div>

          <div style={formGroup}>
            <label style={labelStyle}>Amount</label>
            <input
              type="number"
              name="amount"
              value={formData.amount}
              onChange={handleChange}
              style={inputStyle}
              required
            />
          </div>

          <div style={formGroup}>
            <label style={labelStyle}>Remarks</label>
            <textarea
              name="remarks"
              value={formData.remarks}
              onChange={handleChange}
              style={textareaStyle}
            />
          </div>

          <button type="submit" style={buttonStyle}>
            Create Wallet
          </button>
        </form>
      </div>
    </div>
  );
};

export default ResellerWallet;
